var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.145142 2.42997C0.145142 1.86165 0.370906 1.3166 0.77277 0.914738C1.17463 0.512874 1.71968 0.287109 2.288 0.287109H11.7143C12.2826 0.287109 12.8276 0.512874 13.2295 0.914738C13.6314 1.3166 13.8571 1.86165 13.8571 2.42997V2.43568L7 5.94825L0.145142 2.43797V2.42997ZM0.145142 3.40082V9.00139C0.145142 9.56972 0.370906 10.1148 0.77277 10.5166C1.17463 10.9185 1.71968 11.1443 2.288 11.1443H11.7143C12.2826 11.1443 12.8276 10.9185 13.2295 10.5166C13.6314 10.1148 13.8571 9.56972 13.8571 9.00139V3.39911L7.19543 6.81168C7.13494 6.84267 7.06796 6.85883 7 6.85883C6.93204 6.85883 6.86505 6.84267 6.80457 6.81168L0.145142 3.40082Z",
    fill: "currentColor",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmail);
export default __webpack_public_path__ + "static/media/ic-email.80833fb3c8f3026ad20ad892dd839b7b.svg";
export { ForwardRef as ReactComponent };